import { global } from ":shared/app";

export interface Get {
  props: { id: number };
  returns: any;
}

const endpoint = (props: { id: number }) => `/teaming/cancel-request/${props.id}/`;
export default {
  async get(props: Get["props"]): Promise<Get["returns"]> {
    const ep = endpoint({ id: props.id });
    return global.api.getAuth(ep).then((res) => {
      return res.data;
    });
  },
};
